// extracted by mini-css-extract-plugin
module.exports = {"qasaButton":"QasaPlatformSelectorButton_qasaButton__YEIN_"};